import React from "react";
import TextField from "@mui/material/TextField";
import { formatRackLocationLabel } from "src/utils/rackLocations";

export default function RackLocationsInput({
  disabled,
  rackLocations = [],
  toggleModal,
  onKeyDown,
}) {
  const formattedLocations = rackLocations.map(rl => formatRackLocationLabel(rl, { includeQty: true })).join("\n");

  return (
    <TextField
      fullWidth
      multiline
      disabled={disabled}
      size="small"
      variant="outlined"
      label="Storage Location(s)"
      value={formattedLocations}
      onClick={toggleModal}
      onKeyDown={onKeyDown}
      InputProps={{
        readOnly: true,
      }}
    />
  );
}
